import { create } from 'zustand';

export interface StreamFrameMeta {
  seq?: number;
  capturedAt?: number;
  captureMs?: number;
  encodeMs?: number;
  width?: number;
  quality?: number;
  bytes?: number;
  /** Cumulative count of frames dropped as unchanged static content. */
  skipped?: number;
  /** Cumulative count of frames skipped due to client backpressure. */
  dropped?: number;
  /** Cumulative count of failed captures/encodes this session. */
  failed?: number;
  /** EMA of achieved frames-per-second for sent frames. */
  fps?: number;
  /** Diagnostic (debug=1): measured grid delta vs the previous frame. */
  gridScore?: number;
  /** Diagnostic (debug=1): whether the motion gate saw a content change. */
  motionChanged?: boolean;
  /** Diagnostic (debug=1): whether sustained-motion video mode was active. */
  videoMode?: boolean;
}

interface StreamState {
  connected: boolean;
  activeStreams: Record<string, string | null>;
  frameMeta: Record<string, StreamFrameMeta | null>;
  lastFrame: string | null;
  setConnected: (connected: boolean) => void;
  setActiveStream: (deviceSerial: string, streamData: string | null) => void;
  setFrameMeta: (deviceSerial: string, meta: StreamFrameMeta | null) => void;
  setLastFrame: (data: string | null) => void;
}

export const useStreamStore = create<StreamState>((set) => ({
  connected: false,
  activeStreams: {},
  frameMeta: {},
  lastFrame: null,
  setConnected: (connected: boolean) => set({ connected }),
  setActiveStream: (deviceSerial: string, streamData: string | null) =>
    set((state) => ({
      activeStreams: { ...state.activeStreams, [deviceSerial]: streamData },
    })),
  setFrameMeta: (deviceSerial: string, meta: StreamFrameMeta | null) =>
    set((state) => ({
      frameMeta: { ...state.frameMeta, [deviceSerial]: meta },
    })),
  setLastFrame: (data: string | null) => set({ lastFrame: data }),
}));
